// extracted by mini-css-extract-plugin
export var column = "_t2-0";
export var divider = "_t2-2";
export var timePicker = "_t2-1";